import { V2MicrogridResolvedGetProfitReportPostResponse } from '@maxtropy/intelligent-dispath-apis-v2';
import dayjs from 'dayjs';
import { keepTwoNull } from '../../utils';
import * as echarts from 'echarts';
import { ResolutionEnum } from '../../type';

const areaColors = [
  new echarts.graphic.LinearGradient(0, 0, 0, 1, [
    { offset: 0, color: 'rgba(82, 231, 255,0.2)' },
    { offset: 1, color: 'rgba(82, 231, 255,0.1)' },
  ]),
  new echarts.graphic.LinearGradient(0, 0, 0, 1, [
    { offset: 0, color: 'rgba(250, 204, 88, 0.2)' },
    { offset: 1, color: 'rgba(250, 204, 88, 0.1)' },
  ]),
];

export const getChartOption = (
  resolution: ResolutionEnum,
  chartData?: V2MicrogridResolvedGetProfitReportPostResponse
) => {
  const formatDate = resolution === ResolutionEnum.DAY ? 'HH:mm' : 'MM-DD';

  // 实际值
  let actualData = (chartData?.actValues ?? []).map(item => [dayjs(item.timestamp).valueOf(), keepTwoNull(item.value)]);

  // 算法预测值
  let predictData = (chartData?.predictValues ?? []).map(item => [
    dayjs(item.timestamp).valueOf(),
    keepTwoNull(item.value),
  ]);

  return {
    tooltip: {
      trigger: 'axis',
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let firstStr = dayjs(axisValue).format(formatDate);
        let otherStr = '';
        let str = '';

        items.forEach((item: any) => {
          const { seriesName, data } = item;
          let unit = '元';
          otherStr += `<div style="margin-top:8px"><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${
            item.color
          };"></span>${seriesName} : &nbsp;${data[1] || data[1] === 0 ? data[1] + unit : '-'}</div>`;
          str = firstStr + otherStr;
        });

        return str;
      },
    },
    grid: {
      left: 20,
      right: 20,
      top: 60,
      bottom: 40,
      containLabel: true,
    },
    color: ['rgba(82, 231, 255)', 'rgba(250, 204, 88)'],
    dataZoom: [
      {
        type: 'slider',
        bottom: 10,
        left: 25,
        right: 20,
        height: 20,
        textStyle: {
          fontSize: 10,
        },
        labelFormatter: (value: string) => {
          return dayjs(value).format(formatDate);
        },
      },
    ],
    legend: {
      right: 10,
      itemWidth: 16,
      itemHeight: 4,
      data: [
        {
          name: '实际值',
          icon: 'rect',
        },
        {
          name: '算法预测值',
          icon: 'path://M54 468h261v90H54zM378 468h261v90H378zM702 468h261v90H702z',
        },
      ],
    },
    xAxis: [
      {
        type: 'time',
        minInterval: 60 * 1000 * 60 * 12,
        axisLabel: {
          formatter: function (e: number) {
            return dayjs(e).format(formatDate);
          },
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: '元',
        axisLabel: {
          formatter: '{value}',
        },
      },
    ],
    series: [
      {
        name: '实际值',
        type: 'line',
        data: actualData,
        connectNulls: true,
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        itemStyle: {
          // symbol样式
          normal: {
            borderColor: 'rgba(255, 255, 255, 0.2)', // symbol边框颜色
            borderWidth: 2, // symbol边框宽度
          },
        },
        lineStyle: {
          width: 2,
          type: 'solid', //'dotted'点型虚线 'solid'实线 'dashed'线性虚线
        },
        areaStyle: {
          color: areaColors[0],
        },
      },
      {
        name: '算法预测值',
        type: 'line',
        data: predictData,
        connectNulls: true,
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        itemStyle: {
          // symbol样式
          normal: {
            borderColor: 'rgba(255, 255, 255, 0.2)', // symbol边框颜色
            borderWidth: 2, // symbol边框宽度
          },
        },
        lineStyle: {
          width: 4,
          type: 'dotted', //'dotted'点型虚线 'solid'实线 'dashed'线性虚线
        },
        areaStyle: {
          color: areaColors[1],
        },
      },
    ],
  };
};
